import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: '',
  totalRegistros: 0
}

// getters
const getters = {
}

// actions
const actions = {
  async listBilling ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      let fecdesdeV
      let fechastaV
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      if (params.fecdesde !== undefined) {
        fecdesdeV = params.fecdesde
      }
      if (params.fechasta !== undefined) {
        fechastaV = params.fechasta
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: codcomV,
            fecdesde: fecdesdeV,
            fechasta: fechastaV
          }
        }
      })

      const response = await HTTP.post(config.endpoints.listBilling, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async listInvoices ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      let numrefremV
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      if (params.numrefrem !== undefined) {
        numrefremV = params.numrefrem
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: codcomV,
            numrefrem: numrefremV
          }
        }
      })

      const response = await HTTP.post(config.endpoints.listInvoices, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async listReceipts ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      let codprocesoV
      let clamonV
      let numrefremV
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      if (params.codproceso !== undefined) {
        codprocesoV = params.codproceso
      }
      if (params.clamon !== undefined) {
        clamonV = params.clamon
      }
      if (params.numrefrem !== undefined) {
        numrefremV = params.numrefrem
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: codcomV,
            codproceso: codprocesoV,
            clamon: clamonV,
            numrefrem: numrefremV
          }
        }
      })

      const response = await HTTP.post(config.endpoints.listReceipts, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async listCommissions ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      let fecdesdeV
      let fechastaV
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      if (params.fecdesde !== undefined) {
        fecdesdeV = params.fecdesde
      }
      if (params.fechasta !== undefined) {
        fechastaV = params.fechasta
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: codcomV,
            fecdesde: fecdesdeV,
            fechasta: fechastaV
          }
        }
      })

      const response = await HTTP.post(config.endpoints.listCommissions, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          case 200:
            response.error = true
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno)
            break

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async listRappel ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let fecdesdeV
      let fechastaV
      let tipoestrapV
      let codestrapV
      if (params.codestrap !== undefined) {
        codestrapV = params.codestrap
      }
      if (params.tipoestrap !== undefined) {
        tipoestrapV = params.tipoestrap
      }
      if (params.fecdesde !== undefined) {
        fecdesdeV = params.fecdesde
      }
      if (params.fechasta !== undefined) {
        fechastaV = params.fechasta
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codestrap: codestrapV,
            tipoestrap: tipoestrapV,
            fecdesde: fecdesdeV,
            fechasta: fechastaV
          }
        }
      })

      const response = await HTTP.post(config.endpoints.listRappel, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'BILLING_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'BILLING_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'BILLING_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'BILLING_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
